<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetDIOStatus')
  .row
    .col-xs-12
      fieldset
        legend dxSetDIOConfig
        div(v-for="(id, DI) in DIs")
          span DI {{ id }}: name
          input(type='text' v-model='DI.name')

        div(v-for="(id, DO) in DOs")
          span DO {{ id }}: name
          input(type='text' v-model='DO.name')
        button(@click="dxSetDIOConfig") dxSetDIOConfig
  //- =============== dxSetDOState  =============================
  .row
    .col-xs-12
      fieldset
        legend dxSetDOState
        div(v-for="(id, DO) in DOs")
          span DO {{ id }}: value
          input(type='text' v-model='DO.value')
        button(@click="dxSetDOState") dxSetDOState
  +simpleGetButton('dxGetSchedules')
    //- ============== dxSetSchedules ====================
  .row
    .col-xs-12
      fieldset
        legend dxSetSchedules
        div
          h3
            |schedule
            input(type="number" v-model="dxSetSchedules.no" max='10' min='1')
          span
            |enabled:
            input(type="checkbox" v-model="dxSetSchedules.params.enabled")
          div
            span
              |name:
              input(type="text" v-model="dxSetSchedules.params.name")
          div
            span Actions
            span
              select(v-model='dxSetSchedules.params.action')
                option(value='DO High') Do High
                option(value='DO Low') Do low
          div
            span Target
            span(v-for="i in 4")
              input(type="checkbox" v-bind:value="(i+1).toString()" v-model="dxSetSchedules.params.targets")
              |{{ i+1 }}
          .row
            .col-xs-6
              | hours
              input(type="number" max='23' v-model="dxSetSchedules.params.time.hours")
            .col-xs-6
              | minutes
              input(type="number" max='59' v-model="dxSetSchedules.params.time.minutes")
            .col-xs-12
              | days:
              span(v-for='(key,day) in weekDays')
                input(type="checkbox" v-bind:value="day" v-model='dxSetSchedules.params.time.days')
                label {{day}}
        button(@click="dxSetSchedulesHandler") dxSetSchedules
  +simpleGetButton('dxGetEvents')
  //- ============== dxSetEvents ======================
  .row
    .col-xs-12
      fieldset
        legend dxSetEvents
        div
          h3
            | Event no.
            input(type='number' min="1" max='10' v-model='dxSetEvents.no')
          div
            | enabled:
            input(type="checkbox" v-model='dxSetEvents.content.enabled')
          div
            | event.name
            input(type="text" v-model="dxSetEvents.content.name")
          div
            | event.key: {{ dxSetEvents.content.event.key }}
            //- radio(
            //-   type="info"
            //-   v-bind:checked.sync="dxSetEvents.content.event.key"
            //-   v-for='key in dxSetEvents.keys'
            //-   v-bind:value="key") {{ key }}
          div
            | event.condition:
            label.radio-inline(v-for='condition in dxSetEvents.conditions')
              input(type='radio' v-bind:value="condition" v-model='dxSetEvents.content.event.condition')
              | {{ condition }}
          div
            | event.value
            input.light(type="text" v-model="dxSetEvents.content.event.value" placeholder='High2Low or Low2High')
          div
            fieldset
              legend  Actions
              div(v-for="type in dxSetEvents.actionTypes")
                fieldset
                  legend
                    |{{ type.action }}
                    input(type="checkbox" v-model='type.selected')

                  div(v-if='type.selected && type.show_checkbox_dio')
                    //- this is normal check box selections for do high, do low
                    | Targets:
                    span(v-for="i in 4" )
                      input(type="checkbox" v-bind:value="(i+1).toString()" v-model="type.targets")
                      span DO {{ i+1 }}

                  .form-group(v-if='type.selected && type.show_targets_string')
                    //- this is user input enter ther targets
                    label accounts:
                    textarea.form-control(v-model='type.targets_string')
                    div(v-if='type.show_value')
                      //- this is normal value input for seq on, off(5,6)
                      | Delay Time:
                      input(v-model="type.value")
        button(@click="dxSetEventsHandler") dxSetEvents
</template>

<script>
  export default {
    data: () => ({
      DIs: {
        1: {
          name: 'fan sensor'
        },
        2: {
          name: 'light sensor'
        },
        3: {
          name: 'fan sensor'
        },
        4: {
          name: 'light sensor'
        }
      },
      DOs: {
        1: {
          name: 'alarm LED',
          value: 'low'
        },
        2: {
          name: 'alarm Call',
          value: 'high'
        },
        3: {
          name: 'alarm Call',
          value: 'high'
        },
        4: {
          name: 'alarm Call',
          value: 'high'
        }
      },
      weekDays: ['mon', 'tue', 'wed', 'thr', 'fri', 'sat', 'sun'],
      dxSetSchedules: {
        no: '1',
        params: {
          enabled: true,
          name: 'hahaha',
          action: 'DO High',
          targets: ['1'],
          time: {
            hours: 8,
            minutes: 0,
            days: ['mon', 'tue']
          }
        }
      },
      dxSetEvents: {
        no: '1',
        keys: ['DI'],
        conditions: ['=='],
        actionTypes: [
          // 'Power RESET', 'Power ON', 'Power OFF', // < 3 power
          // 'DO High', 'DO Low', // when < 5 : checkbox
          // 'Email', 'SMS', // when 5 ~ 6 : only textarea
          // 'Sequence ON', 'Sequence OFF' // when >= 7 : show value
          'DO High', 'DO Low', 'Email', 'SMS'
        ].map((action, index) => ({
          selected: false,
          show_checkbox_dio: index <= 1,
          show_targets_string: index > 1 && index < 4,
          show_value: index >= 7,
          action,
          value: '',
          targets_string: 'admin;user1',
          targets: []
        })),
        content: {
          enabled: false,
          name: 'test',
          event: {
            key: 'DI',
            condition: '==',
            value: 'High2Low',
            source: '2'
          },
          actions: []
        }
      }
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetDIOConfig () {
        let DIs = {}
        let DOs = {}
        for (let i in this.DIs) {
          DIs[i] = {
            name: this.DIs[i].name
          }
        }
        for (let i in this.DOs) {
          DOs[i] = {
            name: this.DOs[i].name
          }
        }
        this.sendAPI('dxSetDIOConfig', { DIs, DOs })
      },
      dxSetDOState () {
        let DOs = {}
        for (let i in this.DOs) {
          DOs[i] = {
            value: this.DOs[i].value
          }
        }
        this.sendAPI('dxSetDOState', { DOs })
      },
      dxSetSchedulesHandler () {
        if (this.dxSetSchedules.no > 10 || this.dxSetSchedules.no < 1) return window.alert('only 1-10 schedules number allowed')
        this.sendAPI('dxSetSchedules', {
          entries: {
            [this.dxSetSchedules.no]: this.dxSetSchedules.params
          }
        })
      },
      dxSetEventsHandler () {
        let { content, no } = this.dxSetEvents
        content.actions = this.dxSetEvents.actionTypes
          .map((T, index) => ({
            action: T.selected && T.action,
            value: T.value,
            targets: T.show_targets_string ? T.targets_string.split(';') : T.targets
          }))
          .filter(T => T.action) // filter : not select
        if (content.actions.length === 0) {
          window.alert('at least one action, please!')
        } else {
          this.sendAPI('dxSetEvents', {
            entries: {
              [no]: content
            }
          })
        }
      }
    }
  }
</script>
<style>
  .light::placeholder{
    color:  #aaa;
  }
</style>



// WEBPACK FOOTER //
// dio.vue?6050f378